import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryFilter } from './category-filter.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ CategoryFilter],
  exports: [CategoryFilter]
})
export class CategoryFilterModule {
  static forRoot() {
    return {
        ngModule: CategoryFilterModule,
        providers: [],
    };
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/pipes/category-filter/category-filter.module.ts